import { useSyncExternalStore } from 'react';

import { subscribeInsideChatState, getInsideChatStateSnapshot, getInsideChatServerSnapshot } from '../page/components/inside-chat';

export default () => useSyncExternalStore(subscribeInsideChatState, getInsideChatStateSnapshot, getInsideChatServerSnapshot);
